module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/inspiration-toolbar-50.43957760.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/inspiration-toolbar-50.png
// module id = 3722
// module chunks = 11